import {MatchDetailCleanup} from '../types';
import {MATCHDETAIL_CLEANUP} from '../../actionTypes';

/**
 * The following action creator tells the reducer to clean-up the state
 */
const matchDetailCleanup = (): MatchDetailCleanup => ({
  type: MATCHDETAIL_CLEANUP,
});

export default matchDetailCleanup;
